import { Component, Inject, OnInit, ViewChild, HostListener } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { ToastComponent, ToastPositionModel } from '@syncfusion/ej2-angular-notifications';
import { DialogUtility } from '@syncfusion/ej2-popups';
import { ReCaptcha2Component } from 'ngx-captcha';
import { NgxSpinnerService } from 'ngx-spinner';
import { GOOGLE_RECAPTCHA_SITE_KEY } from 'src/app/core/services/appConfig/app-config.service';
import { AuthenticationService } from 'src/app/core/services/authService/authentication.service';
import { IncidentReportService } from 'src/app/core/services/IncidentReport/incident-report.service';
import { ToastService } from 'src/app/core/services/taoastService/toast-service.service';
import { GlobalConstants } from 'src/app/shared/services/constants/globalconstants';
import { userActions } from 'src/app/store/state/user';

@Component({
    selector: 'app-anonymous-dialog-signin',
    templateUrl: './anonymous-dialog-signin.component.html',
    styleUrls: ['./anonymous-dialog-signin.component.scss'],
    standalone: false
})
export class AnonymousDialogSigninComponent implements OnInit {
  loginForm: UntypedFormGroup;
  dialogObj: any;
  @ViewChild('toasttype')
  public toastObj: ToastComponent;
  public toastPosition: ToastPositionModel = { X: 'Right' };
  submitted = false;
  noComplainantEmailMessage = GlobalConstants.noComplainantEmailMessage;
  showCaptcha = false;
  showCaptchRequiredMessage = false;
  @ViewChild('captchaElem') captchaElem: ReCaptcha2Component;
  siteKey: any;
  respondUser: any;
  public today: Date = new Date();
  constructor(
    private router: Router,
    private formbuilder: UntypedFormBuilder,
    private authenticationService: AuthenticationService,
    private incidentReportService: IncidentReportService,
    private toastService: ToastService,
    private store: Store,
    private spinner: NgxSpinnerService,
    @Inject(GOOGLE_RECAPTCHA_SITE_KEY) public readonly GOOGLE_RECAPTCHA_SITE_KEY?: string) {
    this.siteKey = this.GOOGLE_RECAPTCHA_SITE_KEY;
    this.authenticationService.respondUser.subscribe(respondServiceUser => this.respondUser = respondServiceUser);
  }

  ngOnInit(): void {
    this.loginForm = this.formbuilder.group({
      caseNumber: ['', [Validators.required]],
      pin: ['', [Validators.required]],
      captcha: ['']
    });
    this.authenticationService.getClickEvent().subscribe(() => {
      if (this.dialogObj != null) { this.dialogObj.hide(); }
    });
  }

  @HostListener('window:load')
  onLoad() {
    document.getElementById('e-pre-login-form-box').style.maxHeight = document.getElementById('prelogin-left-image').clientHeight + 'px';
  }
  @HostListener('window:resize')
  onResize() {
    document.getElementById('e-pre-login-form-box').style.maxHeight = document.getElementById('prelogin-left-image').clientHeight + 'px';
  }

  get formControl() {
    return this.loginForm.controls;
  }

  onSubmit() {
    this.submitted = true;
    if (this.loginForm.valid) {
      if (this.showCaptcha && this.captchaElem) {
        const captchaResponse = this.captchaElem.getResponse();
        if (captchaResponse === '') {
          this.showCaptchRequiredMessage = true;
          return;
        }
      }
      this.spinner.show('customSpinner');
      // When CAPTCHA is visible, forward the token to the server for server-side validation.
      const captchaToken = this.showCaptcha ? this.captchaElem?.getResponse() : undefined;
      this.authenticationService.respondLogin(this.formControl.caseNumber.value, this.formControl.pin.value, GlobalConstants.LoginType_Respond, captchaToken)
        .subscribe(RespondUser => {
          this.store.dispatch(userActions.userLoggedIn({ respondUser: RespondUser }));
          this.spinner.hide('customSpinner');
          this.router.navigate(['/anonymousdialogue']);
          if (this.respondUser) {
            const complainantEmail = this.respondUser.ComplainantEmail;
            this.showCaptcha = false;
            if (complainantEmail === null || complainantEmail === '') {
              this.dialogObj = DialogUtility.alert({
                title: 'WARNING',
                content: this.noComplainantEmailMessage,
                okButton: { text: 'Ok' },
                showCloseIcon: false,
                closeOnEscape: false,
                animationSettings: { effect: 'Zoom' },
                zIndex: 1005,
                position: { X: 'center', Y: 'center' },
                isModal: true
              });

            }
          }
        },
          error => {
            this.spinner.hide('customSpinner');
            const currentFailedAttemptCount = Number(error.error.InnerException.Data.pinAuthenticationMsg);
            this.toastObj.show({ content: error.error.Message, cssClass: 'e-toast-danger', icon: 'e-error toast-icons' });
            if (currentFailedAttemptCount >= 2) {
              this.showCaptcha = true;
            }
            if (this.captchaElem) {
              this.captchaElem.reloadCaptcha();
            }
          });
    }
  }

  navigateToUpdatePass() {
    this.dialogObj.hide();
    alert('try another user');
  }

  cancelClick(): void {
    this.dialogObj.hide();
  }

  GoToCreatePin() {
    this.router.navigate(['/createpin']);
  }

  onBeforeOpenToast(e) {
    if (this.toastObj.element.children.length > 0) {
      if (e.options.content == this.toastService.getToastContent()) {
        e.cancel = true;
      }
    } else {
      this.toastService.setToastContent(e.options.content);
    }
  }

  onCloseToast() {
    this.toastService.setToastStatus(false);
  }

  handleCaptchaError() {
    if (this.captchaElem) {
      this.captchaElem.reloadCaptcha();
    }
  }

  handleCaptchaExpire() {
    // Token expired — reset widget and clear form control so stale token cannot be submitted.
    this.showCaptchRequiredMessage = true;
    if (this.captchaElem) {
      this.captchaElem.resetCaptcha();
    }
    this.loginForm.controls['captcha'].setValue(null);
  }
}
